const CLIENT_ID = process.env.NEXT_PUBLIC_OKTA_CLIENT_ID ?? '{clientId}'
const ISSUER =
  process.env.NEXT_PUBLIC_OKTA_ISSUER ?? 'https://{yourOktaDomain}.com/oauth2/{authServerId}'
//const OKTA_TESTING_DISABLEHTTPSCHECK = process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
//const BASENAME = import.meta.env.BASE_URL || '';
const BASENAME = ''
// BASENAME includes trailing slash
const REDIRECT_URI = typeof window !== 'undefined' ? window.location.origin : ''
const USE_INTERACTION_CODE = process.env.NEXT_PUBLIC_OKTA_USE_INTERACTION_CODE === 'true' || false

const config = {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: true,
    useInteractionCode: USE_INTERACTION_CODE,
  },
  resourceServer: {
    messagesUrl: 'http://localhost:8000/api/messages',
  },
  app: {
    basename: BASENAME,
  },
}

export default config
